import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { CellClassRules, ColDef, ColumnApi, GridApi, GridOptions } from 'ag-grid-enterprise';
import * as moment from 'moment';
import { MessageService } from 'primeng/api';
import { ReportService } from '../..';
import { ConstantService } from '@app/_services/constant.service';
import 'ag-grid-enterprise';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-holds-expire-by-property',
    templateUrl: './res-hold-expire-by-property.component.html',
    styleUrls: ['./res-hold-expire-by-property.component.css'],
    standalone: false
})
export class HoldsExpireByPropertyComponent implements OnInit {

	@Input() resRevByDay: any = [];
	@Input() resRevMaster: any = [];
	@Input() groupDefaultExpanded: any = 0;

	constructor(
		private router: Router,
		public messageService: MessageService,
		public reportService: ReportService,
		private constantService: ConstantService,) { }

	gridApi: GridApi;
	columnApi: ColumnApi;

	// ag-grid columns
	occupancyNtsCellClassRule: CellClassRules = this.reportService.occupancyNtsCellClassRule;
	occupancyPctCellClassRule: CellClassRules = this.reportService.occupancyPctCellClassRule;


	autoGroupColumnDef = {
		headerName: 'Property',
		cellRendererParams: {
			suppressCount: true,
		}
	};

	defaultColDef: ColDef = {
		sortable: true,
		filter: true,
	};

	columnDefs: ColDef[] = [
		
		//Columns
		{ headerName: 'Sale Date', field: 'saleDate', cellRenderer: this.fullDateCellRendererUSD, },
		{ headerName: 'Location', field: 'locationId', sortable: true, sort: 'asc', cellRenderer: params => this.getLocationName(params) },
		{ headerName: 'Resort', field: 'developmentName', sortable: true, sort: 'asc' },
		{ headerName: 'Property', field: 'propertyCode', sortable: true },
		{ headerName: 'Order ID', field: 'orderId', sortable: true, sort: 'asc', hide: true },
		{ headerName: 'Nights', field: 'numNtsTTL', aggFunc: 'sum' },
		{ headerName: 'Rate', field: 'revRoomRateNetPNT', cellRenderer: this.currencyCellRendererUSD, aggFunc: 'avg' },
		{ headerName: 'Arrival', field: 'checkInDate', aggFunc: 'showArrivalDate', cellRenderer: this.fullDateCellRendererUSD, },
		{ headerName: 'Departure', field: 'checkOutDate', cellRenderer: this.fullDateCellRendererUSD, },
		{ headerName: 'Revenue', field: 'revRoomRateNetTTL', cellRenderer: this.currencyCellRendererUSD, aggFunc: 'sum' },
		{ headerName: 'Name', field: 'guestLastName', cellRenderer: params => this.getReservationLink(params),
			valueGetter: params => {
				const guestLastName = params?.data?.guestLastName;
				if (!guestLastName || guestLastName.trim() === '.' || guestLastName.trim() === '') {
				  return 'NEED NAME';
				}
				return guestLastName;
			  },
			  aggFunc: (params) => {
				const values = params.values;
				// Filter out "NEED NAME" entries from the values
				const filteredValues = values.filter(value => value !== 'NEED NAME');
				return filteredValues.length > 0 ? '' : '';
			  }
		 },
		{ headerName: 'Type', field: 'resStatus', cellRenderer: params => this.getReservationType(params),
      cellStyle: (params) => this.getColorByReservationType(params)},
		{ headerName: 'Agent', field: 'soldBy', },
		{
			headerName: 'Channel', field: 'refSrcId', width: 60, sortable: true, autoHeight: true,
			cellRenderer: params => this.displayChannelPicture(params),
			filterValueGetter: (params) => {
				// This custom filter will map the filter to the label based on refSrcImages
				const refSrcId = params.data.refSrcId;
				const channel = this.constantService.refSrcImages.find(item => item.value === refSrcId);
				return channel ? channel.label : refSrcId;
			  }
		},
	];

	gridOptions: GridOptions = {
		rowData: this.resRevMaster,
		columnDefs: this.columnDefs,
		pagination: true,
		rowSelection: 'single',
		suppressAggFuncInHeader: true,

		// EVENTS
		// Add event handlers
		onRowClicked: event => console.log('A row was clicked'),
		onColumnResized: event => console.log('A column was resized'),
		onGridReady: event => console.log('The grid is now ready'),

		// CALLBACKS
		getRowHeight: (params) => 25,

		aggFuncs: {
			// this overrides the grids built-in avg function
			'showArrivalDate': params => {
				console.log(JSON.stringify(params.values));
				if (params.values[1]) {
					return params.values[1].checkInDate;
				}
			},
		},

		// Adding custom context menu
		getContextMenuItems: (params) => {
		const defaultItems = params.defaultItems;
		  let result = [
			// 'separator', // Add a separator if needed
			{
			  name: 'Public Website',
			  action: () => {
				console.log(params.node.data.shortTermRentalId);
				this.redirectToPublicSite(params.node.data.shortTermRentalId);
			  },
			//   icon: '<i class="fas fa-cogs"></i>' 
			},
			{
				name: 'Season Summary',
				action: () => {
				  console.log(params.node.data.shortTermRentalId);
				  this.redirectToSeasonSummary(params.node.data.shortTermRentalId);
				},
			  //   icon: '<i class="fas fa-cogs"></i>' 
			},
			{
				name: 'View This Reservation',
				action: () => {
				  const orderId = params.node.data?.orderId;
				  if (orderId) {
					const url = `https://admin.kbmhawaii.com/order/${orderId}`;
					window.open(url, '_blank'); // Opens in a new tab
				  } else {
					console.warn('No Order ID found for this row');
				  }
				},
			},
			{
				name: 'View Property Reservations',
				action: () => {
				  const propertyCode = params.node.data?.propertyCode;
				  if (propertyCode) {
					const url = `https://admin.kbmhawaii.com/reservations/property/${propertyCode}`;
					window.open(url, '_blank'); // Opens in a new tab
				  } else {
					console.warn('No Property Code found for this row');
				  }
				},
			  },
    			'separator',
		  ];
	  
		  // Merge custom and default items
  		  return [...result, ...defaultItems];
		}
	}


	// forms
	formLoading = false;


	// to hold the current search
	currentSearchForm: any;


	// data
	// resRevMaster: any[];
	resRevMasterByDay: any[];
	resRevTotal: any[];
	resRevTotalByDay: any[];
	resRevTotalByMonth: any[];
	resRevTotalByYear: any[];


	// search defaults
	defaultStartDate: Date
	defaultEndDate: Date
	defaultReservationStatuses: any;
	defaultShortTermRentalIds: any;

	getReservationType(params: any) {
		if (params.value) {
			if (params.value == "OP") {
				return "Guest"
			} else if (params.value == "OO") {
				return "Owner"
			} else if (params.value == "OG") {
				return "Owner Guest"
			} else if (params.value == "NA") {
				return "Maintenance"
			} else if (params.value == "OX") {
				return "Cancel"
			}
		}
	};

  getColorByReservationType(params: any){
    if (params.value) {
      if (params.value == "OP") {
        return { color: 'black', backgroundColor: "lightgrey" };
      } else if (params.value == "OO") {
        return { color: 'black', backgroundColor: "hotpink"};
      } else if (params.value == "OG") {
        return { color: 'black', backgroundColor: "lightpink"};
      } else if (params.value == "NA") {
        return { color: 'black', backgroundColor: "darkgray"};
      } else if (params.value == "OX") {
        return { color: 'black', backgroundColor: "red"};
      }
    }
  }

  /**
   * Redirect to Public website
   */
  redirectToPublicSite(shortTermRentalId:any)
  {
   let baseUrl = 'https://www.kbmresorts.com/vacation-rentals';
   if(shortTermRentalId != null)
   {
	 baseUrl = baseUrl + '/' + shortTermRentalId;
   }
   window.open(baseUrl, '_blank');
  }

  /**
   * Redirect to Season Summary
   */
  redirectToSeasonSummary(shortTermRentalId:any)
  {
   let baseUrl = '/yield-max/5/'+shortTermRentalId;
   const url = this.router.serializeUrl(
     this.router.createUrlTree([baseUrl])
     );
     window.open(url, '_blank');
  }

	displayChannelPicture(params: any) {
		if (params.value) {
			return "<img style='height: 16px; width: auto; object-fit:contain' src='" + this.constantService.refSrcImages.find(function(item) { return item.value == params.value })?.imgurl + "'>"
		}
	};

	getLocationName(params: any) {
		if (params.value) {
			return this.constantService.locations.find(function(item) {
				return item.locationId == params.value
			})?.name;
		}
	};

	getReservationLink(params: any) {
		if (params.value) {
			let url = "https://admin.kbmhawaii.com/order/" + params?.data?.orderId;
			return '<a href=' + url + ' target="_blank">' + params.value + '</a>'
		}
	};

	getRentedPercent(params: any) {
		return (params?.data?.numNightsTTL / params?.data?.numNtsInMonthTTL)
	}

	onRowGroupOpened(event) {
		this.columnApi.autoSizeAllColumns();
	}

	getNtsAvailToRent(params: any) {
		let ntsAvailToRent = new Date(moment(params?.data?.date).year(), moment(params?.data?.date).month(), 0).getDate() - (params?.data?.numNtsOwnerTTL + params?.data?.numNtsOwnerGuestTTL + params?.data?.numNtsMaintTTL);
		console.log('ntsAvailToRent' + ntsAvailToRent);
		return ntsAvailToRent;
	}

	getDaysInMonth(month: number, year: number) {
		console.log('days ' + new Date(year, month, 0).getDate());
		return new Date(year, month, 0).getDate();
	}


	getYearFromDate(params: any) {
		return moment(params?.data?.saleDate).format('YYYY')
	}

	getMonthFromDate(params: any) {
		return moment(params?.data?.saleDate).format('MMM');
	}

	getDayFromDate(params: any) {
		return parseInt(moment(params?.data?.saleDate).format('DD'));
	}



	getGuestName(params: any) {
		if (params.data) {
			return moment(params?.data?.checkInDate).format('MM/DD/YY') + ' - ' + moment(params?.data?.checkOutDate).format('MM/DD/YY') + '   #' + params?.data?.reservationId + ' ' + params?.data?.guestLastName;
		}
		return '';
	}

	getStayDates(params: any) {
		if (params.data) {
			return params?.data?.checkInDate + ' - ' + params?.data?.checkInDate;
		}
		return '';
	}

	currencyCellRendererUSD(params: any) {
		let inrFormat = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		});
		return inrFormat.format(params.value);
	}

	percentCellRenderer(params: any) {
		let inrFormat = new Intl.NumberFormat('en-US', {
			style: 'percent',
			minimumFractionDigits: 1,
			maximumFractionDigits: 1
		});
		return inrFormat.format(params.value);
	}

	fullDateCellRendererUSD(params: any) {
		if (params.data && params.value) {
			return moment(params.value).format('MM/DD/YY');
		}
		return '';
	}

	ngOnInit(): void {
		this.defaultStartDate = new Date();
		// this.defaultStartDate = new Date(this.defaultStartDate.getFullYear()-4, this.defaultStartDate.getMonth(), 1);
		this.defaultStartDate = new Date(this.defaultStartDate.getFullYear(), 0, 1); // jan 1
		this.defaultEndDate = new Date();
		this.defaultEndDate = new Date(this.defaultEndDate.getFullYear(), 12, 0);

		this.defaultReservationStatuses = ['OP', 'OO', 'OG'];
		this.defaultShortTermRentalIds = [1];

		// ag-grid
		this.gridOptions.rowData = this.resRevMaster;
		this.gridOptions.columnDefs = this.columnDefs;
		this.gridOptions.autoGroupColumnDef = this.autoGroupColumnDef;
		this.gridOptions.pagination = true;
		this.gridOptions.suppressAggFuncInHeader = true;
		this.gridOptions.animateRows = true;
		this.gridOptions.defaultColDef = this.defaultColDef;

		// Pivot
		// this.gridOptions.pivotMode = true;
		// this.gridOptions.pivotColumnGroupTotals= 'before';
		// this.gridOptions.pivotRowTotals = 'before';

		// Footer
		this.gridOptions.groupIncludeFooter = true;
		this.gridOptions.groupIncludeTotalFooter = true;

		// https://www.ag-grid.com/javascript-data-grid/column-sizing/
		// this.gridOptions.suppressColumnVirtualisation = true;
	}

	ngAfterViewInit(): void {
		(this.gridOptions as any).api?.setColumnDefs(this.columnDefs);
	}

	onGridReady(grid: any): void {
		this.gridApi = grid;
		this.columnApi = grid.columnApi;

	}
	onFirstDataRendered(params: any): void {
		setTimeout(() => { this.columnApi.autoSizeAllColumns(); }, 5000);
	}

}
